import React from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import BackgroundImage from 'gatsby-background-image';
import ReactMarkdown from 'react-markdown';
import SbEditable from 'storyblok-react';
import Moment from 'react-moment';

import Components from '../components.js';
import Navi from '../Navi/index.js';
import Footer from '../Footer/index.js';
import { fluidImage } from '../../utils/gatsbyImageTransform';
import './blog-post.scss';

const BlogPost = (props) => {
  const naviBlok = { theme: props.blok.header_theme, phone_number: props.blok.header_phone };

  let optimizedFluidImage = fluidImage(props.blok.image.filename, {
    maxWidth: 2160,
  });

  const headerClasses = ['header'];
  headerClasses.push('theme-' + props.blok.header_theme);

  return (
    <SbEditable content={props.blok}>
      <Helmet>
        <title>{props.blok.title} - Swell Energy</title>
        <meta name="description" content={props.blok.intro} />
        <meta property="og:title" content={props.blok.title} />
        <meta property="og:description" content={props.blok.intro} />
        <meta property="og:type" content="article" />
        <meta property="og:image" content={props.blok.image.filename} />
      </Helmet>
      <div className="blog-post">
        <Navi blok={naviBlok}></Navi>
        <Wrapper fluid={optimizedFluidImage} className={headerClasses.join(' ')}>
          <h1>{props.blok.title}</h1>
          <PostInfo>
            <Avatar url={props.blok.avatar.filename} />
            <Author>by {props.blok.author}</Author>
            {props.blok.display_publish_date && (
              <div>
                <Moment format="LL">{props.blok.display_publish_date}</Moment>
              </div>
            )}
            <div>{props.blok.category}</div>
          </PostInfo>
        </Wrapper>
        <div className="body">
          <p className="intro">{props.blok.intro}</p>
          {props.blok.above_post_content &&
            props.blok.above_post_content.map((blok) =>
              React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
            )}
          <ReactMarkdown children={props.blok.long_text} />
          {props.blok.below_post_content &&
            props.blok.below_post_content.map((blok) =>
              React.createElement(Components(blok.component), { key: blok._uid, blok: blok })
            )}
        </div>
        <Footer blok={{}}></Footer>
      </div>
    </SbEditable>
  );
};

export default BlogPost;

const Wrapper = styled((props) => <BackgroundImage {...props} />)`
  width: 100%;
  min-height: 50vh;
  background-position: center center;
  background-size: cover;
  background-color: rgba(0, 0, 0, 0.5);
  background-blend-mode: overlay;
  display: flex;
  flex-direction: column;
  padding-top: 8rem;
  padding-bottom: 1rem;
`;

const PostInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Avatar = styled.div`
  height: 100px;
  width: 100px;
  border-radius: 50%;
  background-size: cover;
  background-image: url(${(props) => props.url});
`;

const Author = styled.span`
  margin-top: 1rem;
`;
